import { ReactNode } from "react";
import { Box, Drawer, IconButton, Tooltip, useTheme } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";

// ----------------------------------------------------------------------

interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
  /** Conteúdo do cabeçalho (à esquerda do X) */
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  width?: number;
}

/** Drawer lateral direito do redesign (fichas de ativo/veículo) */
export default function SideDrawer({ open, onClose, header, footer, children, width = 460 }: SideDrawerProps) {
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{ backdrop: { sx: { backdropFilter: "blur(4px)" } } }}
      PaperProps={{
        sx: {
          width,
          maxWidth: "92vw",
          display: "flex",
          flexDirection: "column",
          backgroundImage: "none",
        },
      }}
    >
      <Box
        sx={{
          p: "26px 28px 20px",
          borderBottom: `1px solid ${theme.palette.divider}`,
          display: "flex",
          alignItems: "flex-start",
          gap: 1.75,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, width: 0, overflow: "hidden" }}>{header}</Box>
        <Tooltip title="Fechar" placement="left">
          <IconButton
            onClick={onClose}
            aria-label="Fechar"
            sx={{
              width: 34,
              height: 34,
              flexShrink: 0,
              borderRadius: "10px",
              backgroundColor: theme.palette.brand.surface2,
              color: "secondary.main",
            }}
          >
            <CloseRounded sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto", p: "24px 28px" }}>{children}</Box>

      {footer && (
        <Box sx={{ p: "16px 28px", borderTop: `1px solid ${theme.palette.divider}` }}>{footer}</Box>
      )}
    </Drawer>
  );
}
